import { useSelector } from 'react-redux'
import { Bar } from 'recharts'
import { CalculateSize } from '../../../../../common/CalculateSize'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Line from '../../../../../common/chart/chartContainer/Line'
import { MARGIN_CHART } from '../../../../../common/chart/chartContainer/constants'
import { Notification } from '../../../../../common/notification'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import {
  convertData,
  formatText,
  formatVal,
  valToPercent,
} from '../../../../../helpers/value'
import { UNIT } from '../../constants'
import { LegendCommon } from './LegendCommon'
import { COLORS } from './constants'

const getListIndexOfLineKeys = (firstItem) => {
  const result = []

  for (let index = 1; index < firstItem.numKey; index++) {
    result.push(index)
  }

  return result
}

export const ComposeChart = ({ chartData }) => {
  const { getExchangeRate, multiplier } = useFormatCurrency(
    SCREEN.INDUSTRY_ANALYSIS,
  )

  const locale = useSelector((state) => state.i18n.locale)
  const firstItem = chartData.length ? chartData[0] : {}
  const listIndexOfLineKeys = getListIndexOfLineKeys(firstItem)
  const indicatorById = {}

  Object.keys(firstItem).forEach((item) => {
    indicatorById[item] = { exchangeRateType: 'lastDayRate' }
  })

  if (firstItem.unitType === UNIT.value.key) {
    chartData = convertData(
      chartData,
      getExchangeRate,
      indicatorById,
      multiplier,
      [
        'label',
        'name0',
        ...listIndexOfLineKeys.map((item) => 'name' + item),
        'unitType',
      ],
    )
  }

  const getFormattedData = (val) => {
    switch (firstItem.unitType) {
      case UNIT['%'].key:
        return valToPercent(val, locale)

      case UNIT.value.key:
        return formatVal(val, locale)

      default:
        return formatVal(val, locale)
    }
  }

  if (!chartData.length) {
    return <Notification />
  }

  return (
    <div className="h100 flexColumn">
      <div className="flex1 positionRelative">
        <CalculateSize height="100%">
          {(size) => {
            return (
              <ChartContainer
                data={chartData}
                width={'100%'}
                height={size.height}
                margin={{ ...MARGIN_CHART, left: 0 }}
                yAxis={[
                  {
                    yAxisId: 'right',
                    dataKeys: [
                      'data',
                      ...listIndexOfLineKeys.map((item) => 'line' + item),
                    ],
                    isBarChart: true,
                    tickFormatter: getFormattedData,
                  },
                ]}
                xAxis={[{ dataKey: 'label' }]}
                tooltip={{
                  schema: {
                    content: [
                      {
                        dataKey: 'data',
                        label: formatText(firstItem.name0),
                        formatValue: getFormattedData,
                      },
                      ...listIndexOfLineKeys.map((item) => {
                        return {
                          dataKey: 'line' + item,
                          label: formatText(firstItem['name' + item]),
                          formatValue: getFormattedData,
                        }
                      }),
                    ],
                  },
                }}
              >
                <Bar
                  yAxisId="right"
                  dataKey={'data'}
                  fill="#006AA6"
                  barSize={32}
                />
                {listIndexOfLineKeys.map((item) => (
                  <Line
                    key={item}
                    yAxisId="right"
                    dataKey={'line' + item}
                    stroke={COLORS[item]}
                    fill={COLORS[item]}
                  />
                ))}
              </ChartContainer>
            )
          }}
        </CalculateSize>
      </div>

      <LegendCommon
        firstItem={firstItem}
        listIndexOfLineKeys={listIndexOfLineKeys}
      />
    </div>
  )
}
